import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { createPortal } from "react-dom";

const DeleteConfirmationModal = ({
    itemName,
    onConfirm,
    onClose,
    loading = false,
    isOpen
}) => {
    if (!isOpen) return null; // Only render if open

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return createPortal(
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
            onClick={handleBackdropClick}
        >
            <div className="bg-white w-full max-w-sm rounded-lg shadow-lg overflow-hidden">

                {/* Header */}
                <div className="flex justify-between items-center border-b px-5 py-3">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Confirm Deletion
                    </h2>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        disabled={loading}
                        className="text-gray-500 hover:text-gray-700 transition"
                    >
                        <AiOutlineClose size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="px-5 py-6 text-center">
                    <p className="text-gray-600 text-sm">
                        Are you sure you want to delete{" "}
                        <span className="font-medium text-red-600">{itemName}</span>?<br />
                        This action cannot be undone.
                    </p>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 px-5 pb-4">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className={`px-4 py-2 rounded-lg border text-sm font-medium transition ${loading
                                ? "opacity-60 cursor-not-allowed"
                                : "hover:bg-gray-100 border-gray-300 text-gray-700"
                            }`}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className={`px-4 py-2 rounded-lg text-sm font-medium text-white transition ${loading
                                ? "opacity-60 cursor-not-allowed bg-red-500"
                                : "bg-red-500 hover:bg-red-600"
                            }`}
                    >
                        {loading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default DeleteConfirmationModal;
